/* EREME: termin wysyłki i dostawy oraz metody płatności pod przyciskiem „Dodaj do koszyka”.
   Zasady jak w regulaminie (§ 4): zamówienia z dni roboczych do 14:00 wysyłamy tego samego dnia,
   pozostałe następnego dnia roboczego; dostawa w Polsce trwa zwykle 1–2 dni robocze.
   Ikony płatności pochodzą z <template id="erdv-pay"> w snippets/ereme-paczkomat.liquid. */
(function () {
  if (window.__erdv) return;
  window.__erdv = true;

  var CUTOFF = 14;
  // Dni wolne od pracy w Polsce, w które nie wysyłamy (RRRR-MM-DD). Uzupełnij na kolejne lata.
  var HOLIDAYS = ['2026-11-11', '2026-12-24', '2026-12-25', '2026-12-26', '2027-01-01', '2027-01-06',
    '2027-03-29', '2027-05-01', '2027-05-03', '2027-05-27', '2027-08-15', '2027-11-01', '2027-11-11',
    '2027-12-24', '2027-12-25', '2027-12-26'];
  var DAYS = ['niedziela', 'poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota'];
  var ON_DAY = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę', 'w czwartek', 'w piątek', 'w sobotę'];

  function warsawNow() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Warsaw', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { date: new Date(Date.UTC(+p.year, +p.month - 1, +p.day)), hour: +p.hour % 24, minute: +p.minute };
  }
  function key(d) { return d.toISOString().slice(0, 10); }
  function addDays(d, n) { return new Date(d.getTime() + n * 864e5); }
  function workday(d) { var w = d.getUTCDay(); return w !== 0 && w !== 6 && HOLIDAYS.indexOf(key(d)) < 0; }
  function nextWorkday(d) { do { d = addDays(d, 1); } while (!workday(d)); return d; }
  function short(d) { var m = d.getUTCMonth() + 1; return DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + '.' + (m < 10 ? '0' : '') + m; }

  function lines() {
    var now = warsawNow(), today = now.date, ship, first;
    if (workday(today) && now.hour < CUTOFF) {
      ship = today;
      var left = (CUTOFF - now.hour) * 60 - now.minute, h = Math.floor(left / 60), m = left % 60;
      // Odliczanie tylko na ostatnie 3 godziny; wcześniej sama godzina graniczna.
      first = left > 180 ? 'Zamów do <b>14:00</b>, a wyślemy dziś.'
        : 'Zamów w ciągu <b>' + (h ? h + ' h ' : '') + m + ' min</b>, a wyślemy dziś.';
    } else {
      ship = nextWorkday(today);
      first = 'Zamów teraz, a wyślemy <b>' + (key(ship) === key(addDays(today, 1)) ? 'jutro' : ON_DAY[ship.getUTCDay()]) + '</b>.';
    }
    var d1 = nextWorkday(ship), d2 = nextWorkday(d1);
    return [first, 'Dostawa do Paczkomatu zwykle: <b>' + short(d1) + '</b> lub ' + short(d2) + '.'];
  }

  var TRUCK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/></svg>';
  var BOX = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 7.5 12 3l9 4.5v9L12 21l-9-4.5z"/><path d="M3 7.5 12 12l9-4.5M12 12v9"/></svg>';

  // Zgodnie z regulaminem § 5 i stroną /pages/zwroty: 30 dni na odstąpienie od umowy.
  var RETURN = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M4 9h11a5 5 0 0 1 0 10H9"/><path d="M8 5 4 9l4 4"/></svg>';

  function render(box) {
    var l = lines(), pay = document.getElementById('erdv-pay');
    var html = '<p class="erdv__row">' + TRUCK + '<span>' + l[0] + '</span></p>' +
      '<p class="erdv__row">' + BOX + '<span>' + l[1] + '</span></p>' +
      '<p class="erdv__row">' + RETURN + '<span><b>30 dni na zwrot</b> bez podawania przyczyny.</span></p>';
    if (pay && pay.innerHTML.trim()) html += '<div class="erdv__pay"><span>Bezpieczna płatność:</span>' + pay.innerHTML + '</div>';
    // Porównujemy z zapamiętanym źródłem, bo innerHTML po serializacji może się różnić i observer kręciłby się w kółko.
    if (box.__erdv === html) return;
    box.__erdv = html;
    box.innerHTML = html;
  }

  function update() {
    document.querySelectorAll('product-form-component').forEach(function (form) {
      if (!form.querySelector('button[name="add"]')) return;
      var box = form.nextElementSibling;
      if (!box || !box.hasAttribute('data-erdv')) {
        box = document.createElement('div');
        box.className = 'erdv';
        box.setAttribute('data-erdv', '');
        form.parentNode.insertBefore(box, form.nextSibling);
      }
      render(box);
    });
  }

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(update, 30000);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();
})();
